import React from "react";
import i18n from "../../../../../../constants/i18n";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import getReportsStore from "../../../../../../stores/reports-store";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";
import { getPermissionIDRequired } from "../../../../../../helpers/et3-has-permission";

const UserReported = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const currentUserIsUnderCsrReport =
    advancedStore.currentUserIsUnderCsrReport.get();
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const hasReportsPermission =
    getCorePersonalStore()
      .userPermissions.get()
      .indexOf(getPermissionIDRequired("Reports")) > -1;

  return isAnyKhattabaAdmin ? null : (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={230}
        height={36}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={currentUserIsUnderCsrReport ? colors.all.blue : colors.all.gray}
        style={{
          borderRadius: 20,
          cursor: "pointer"
        }}
        onClick={() => {
          if (currentUserIsUnderCsrReport && hasReportsPermission) {
            getReportsStore().getReportByUserID(
              advancedStore.currentUserId.get()
            );
          }
        }}
      >
        <Et3Text
          text={i18n.get("REPORTED")}
          fontFamily="BOLD"
          fontSize={15}
          color={colors.all.white}
          isSpan={true}
          style={{}}
        />
      </ET3Div>
      <Et3Margin top={10} bottom={0} left={0} right={0} />
    </React.Fragment>
  );
});
export default UserReported;
